<template>
<div class="industrialpark" >
	<leftnav class="fl" :mkcode="curWebsite.type == 5 ? 'C':'B'" :itemcode="curWebsite.type == 5 ? 'C-YQQYTJ':'B-CYYQK'"></leftnav> 
	<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
		<govheader></govheader>
		<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
		<div class="index_left_centerpage">
			<div class="whitebox right_topbox">
				<div class="right_boxtitle">
					<span class="fl right_title">{{curWebsite.type == 5?'园区企业推荐':'园区'}}</span> 
					<div class="fl search-box nz-search-box">
						<span class="searchtype">园区</span>
						<input type="text" placeholder="请输入园区名称" class="search-input" v-model="searchtext" @keydown="searchenter" />
						<button class="search-btn" @click="searchkwfun">查询</button>
					</div>
					<video-teaching :type="2"  seat="top"></video-teaching>
				</div> 
				<dl class="opport-screen bdbe">
					<dt class="fl">省份地区</dt>
					<dd class="fl">
						<span :class="provinceid == 0?'current a-screen':'a-screen'" @click="cityidchoose('p',0,'all');">全国地区</span>
						<span v-for="(item,index) in prooptions" :key="index"	@click="cityidchoose('p',item.areaId,index);"	:class="item.areaId == provinceid?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
					</dd>
				</dl>
				<dl class="opport-screen bdbe" v-show="cityoptions.length!=0">
					<dt class="fl">城市地区</dt>
					<dd class="fl">
						<span :class="cityid == 0?'current a-screen':'a-screen'"	@click="cityidchoose('c',0,'all');">全部</span>
						<span v-for="(item,index) in cityoptions" :key="index"	@click="cityidchoose('c',item.areaId,index);cityid=item.areaId;userdata.cityText=item.name":data="item.areaId"	:class=" item.areaId == cityid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
					</dd>
				</dl>
				<dl class="opport-screen bdbe" v-show="countyoptions.length!=0">
					<dt class="fl">区县地区</dt>
					<dd class="fl">
						<span :class="countyid == 0?'current a-screen':'a-screen'"	@click="cityidchoose('y',0);">全部</span>
						<span v-for="(item,index) in countyoptions" :key="index" @click="cityidchoose('y',item.areaId);":data="item.areaId"	:class=" item.areaId == countyid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
					</dd>
				</dl>
				
				
<!-- 				<table border="0" cellspacing="0" cellpadding="0">
					<tr>
						<td>所在区域</td>
						<td> 
								<el-select v-model="proid" placeholder="选择所在省份" @change="provincechoose(proid)" > 
								    <el-option
								      v-for="(item,i) in prooptions"
								      :key="item.areaId"
								      :label="item.areaName"
								      :value="item.areaId"
														 >
								    </el-option>
								  </el-select>
										<el-select v-model="cityid" placeholder="选择所在城市" @change="citychoose(cityid)" v-show="cityoptions.length>0">
										    <el-option
										      v-for="item in cityoptions"
										      :key="item.areaId"
										      :label="item.areaName"
										      :value="item.areaId">
										    </el-option>
										  </el-select>
										<el-select v-model="countyid" placeholder="选择所在区域" v-show="countyoptions.length>0">
										    <el-option
										      v-for="item in countyoptions"
										      :key="item.areaId"
										      :label="item.areaName"
										      :value="item.areaId">
										    </el-option>
										  </el-select>
									
						</td>
						</tr> 
							<td></td>
							<td>  
							<p><span class="gov_screen" @click="getlist(1)">筛选</span> </p>
							</td>
					</tr>
				</table> -->
			</div> 
			<div class="whitebox" style="padding-bottom: 50px;">
				<div class="enterparise_guide oh" style="width: 95%; ">
					<p class="fl" v-if="!kwtextsearch" >优质园区<span class="searchnum orangefont">{{total}}</span>家
					</p> 
				</div>
				<div class="enterprise_list_box"  >
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
						<tr>
							<th class="xuhaotd">序号</th>
							<th class=" ">园区名称</th>
							<th>省份</th>
							<th>城市</th>
							<!-- <th>地区</th> -->
							<!-- <th>约面积（亩）</th> -->
							<th>企业数</th>
							<th>关注时间</th>
							<th>编辑</th>
						</tr>
						 <tr v-for="(item,i) in parkdata">
						 	<td>{{20*(page-1)+i+1}}</td>
						 	<td class="indust_parkname" @click="detailrouterto('/industrialparkDetail',item.id)">{{item.parkName}}</td>
						 	<td>{{item.areaText.substring(0,3)}}</td>
						 	<td>
									<span v-if="item.areaText.substring(3,6) !=''">{{item.areaText.substring(3,6)}}</span>
									<span v-if="item.areaText.substring(3,6) ==''">-</span>
								</td>
						 	<!-- <td>{{item.region}}</td> -->
						 	<!-- <td>{{item.area}}</td> -->
								<td>{{item.enterpriseCount}}</td>
								<td>
									<span v-if="item.collectTime!=''">{{item.collectTime}}</span>
									<span v-if="item.collectTime==''">-</span>
								</td>
								<td class="collectfont1"><span  @click="listToggleCollect(item,'acoc')">{{item.collectId == 0?'加入':'移除'}}关注</span></td>
						 </tr>  
					</table> 
				</div>
				<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total" v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
				</zpagenav>
			</div>
		</div>
	</div>
</div>
</template>

<script>
	import { dataInJs } from "../../utils/city.js";
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'index',
		computed: {
		...mapState({
		// isCollapse: (state) => state.app.isCollapse,
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return { 
				curWebsite:this.$api.getWebsiteType(),
				title: "产业园区库",
				isShowFreeUserTips:false,
				usernotionlistsave:[],
				islogin: false,
				userdata:{}, 
				kwtextsearch:'',
				searchtext:'',
				parkdata:[{areaText:''}], 
				prooptions:[],
				provinceid:0,
				cityoptions:[],
				cityid:0,
				countyoptions:[],
				countyid:0, 			
			page: 1,  //显示的是哪一页
			haspage:true,//是否还有下一页
			pageSize: 20, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage:1,
			maxPage:10,  //最大页数
			kw:'',//搜索关键词  
			areadata:dataInJs(), //省份城市数据
			} 
		},  
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},
		created() { 
		 var _this=this;  
			this.userdata = this.getuseriformation();
			this.getprov(); 
				this.$nextTick(() => {
				        // 禁用右键
				        document.oncontextmenu = new Function("event.returnValue=false");
				        // 禁用选择
				        document.onselectstart = new Function("event.returnValue=false");
				      }); 
			
			},
			mounted(){
				document.getElementById('app').style.background = "#f0f3f5";
				this.bus.$emit('loading', true);
				if(this.userdata.edition<1){
					var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
					setTimeout(function(){
						_this.routerself('/totalEnterprises');
					},1000)
					return;
				}
				this.getlist();
				// this.pageHandler(1);
			},
		methods: {  
			cityidchoose(step,id,eqn){
				 if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				 }
				
				//0906关闭市区选择 只留省份
				if(step == 'p'){
					this.provinceid=id;
				}
				this.getlist(); 
			},  
			getlist(pages,type,kw){  
					var _this=this;
					var ajpage=1;
					if(pages){
						ajpage=pages;
					} 
					this.page=ajpage;
					var ajaxurl = this.$api.cyl.park.list()+'?page='+ajpage+'&province='+this.provinceid+'&city='+this.cityid+'&county='+this.countyid;
					//搜索暂时不能用500后台接口问题
					if(type=='search'){
						ajaxurl =this.$api.cyl.park.list()+'?kw='+kw;
					}
					// this.bus.$emit('loading', true);  
					this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						console.log("园区列表",res);
						if(res.data.success){   
							console.log(ajaxurl);
							_this.parkdata = res.data.list; 
							_this.bus.$emit('loading', false);
							_this.totalPage=res.data.totalPage;
							// _this.maxPage=res.data.totalPage;
							_this.pageSize=res.data.pageSize;  
							_this.total=res.data.totalRecord;  
							_this.haspage=res.data.list.length  == res.data.pageSize; 
						}
						else{ 
								
						} 
					}).catch(function (error) {
						// 请求失败处理 console.log(error);
					});  
				
			},
			getprov(){ //获取省份
				 var _this=this;  
				// this.$axios.get(this.$api.cyl.area.get(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
				// 	console.log('省份',res.data);
				// 	if(res.data.success){  
				// 		_this.prooptions = res.data.list;
				// 		_this.prooptions.unshift({areaId: 0,areaName: "请选择"});
				// 	} 
				// }).catch(function (error) { 
				// 	// 请求失败处理 console.log(error);
				// });  
				_this.prooptions = this.areadata; 
			},  
			pageHandler: function (page) {
				this.notioneditbtn=false;
				this.getlist(page,''); 
			},
			//园区详情跳转
				detailrouterto(path,id,code){
					this.routerlinkarry(path,{type:2,id:id,code:code});
			},  
			//添加删除收藏
			// collectFun(type,data){
			// 	console.log(data); 
			// 	var _this=this,cid=data.collectId;
			// 	console.log('cid',cid,type);
			// 	var ajaxurl="",ajaxdata={};
			// 	if(cid == 0){
			// 	 ajaxurl=this.$api.cyl.collect.add();
			// 		ajaxdata={type:type,id:data.id}
			// 		}else{
			// 			ajaxurl=this.$api.cyl.collect.remove();
			// 			ajaxdata={collectId:cid};
			// 		} 
			// 	$.ajax({
			// 		type:"POST",
			// 		url:ajaxurl,
			// 		data:ajaxdata,
			// 		headers:{AuthToken:this.userdata.token },
			// 		success:function(res){ 
			// 			console.log(ajaxurl,ajaxdata);
			// 			console.log('jkljk',res);
			// 			if(res.success){
			// 				if(cid == 0){
			// 					data.collectId=res.data.collectId; 
			// 				}else{
			// 					data.collectId=0;
			// 				}
			// 					_this.getlist();
			// 			} 
			// 		} 
			// 	}) 
			// },
		
			//搜索关键词
			searchkwfun(){ 
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					this.searchtext ='';
					return;
				 }
				this.getlist(1,'search',this.searchtext);
				// if(this.searchtext!="" || ){
				// this.ajaxsearchcompany();
				// } 
			},
			searchenter(e){ 
				if(e.keyCode == 13){
					this.searchkwfun();
				}
			}, 
			  
		}
		}
</script>

<style> 
</style>
